<template>
   <div id="login">
    <div class="center">


      <div class="content">
        <el-form :model="ReginForm" ref="ReginForm" :rules="rule" class="regform" label-width="0">
          <div class="login-text">
            <span class="title">账号登录</span>
          </div>

          <el-form-item prop="userName" class="pastop">
            <!-- <el-col :span="24"> <span class="span_red">仅支持中国大陆地区手机号码。</span> </el-col> -->

            <el-col :span="22" class="col1">
              <el-input
                name="userName121"
                id="enterName"
                class="input-backgroud"
                autocomplete="off"
                placeholder="用户名"
                v-model="ReginForm.userName"
                maxlength="20"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="pastop" prop="password">
            <el-col :span="22" class="col1">
              <el-input
                name="userName111"
                id="enterName1"
                autocomplete="off"
                :type="ReginForm.show.old?'text':'password'"
                v-model="ReginForm.password"
                placeholder="请输入密码"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="pastop" prop="imgCode">
            <el-col :span="22" class="col1">
              <el-input
                name="userName111"
                id="enterName1"
                autocomplete="off"
                v-model="ReginForm.imgCode"
                placeholder="请输入验证码"
              />
              <img
                id="verifyCode"
                width="100%"
                height="32px"
                :src="'data:image/jpeg;base64,'+verifyCode"
                v-on:click="GetImgCode"
              >
            </el-col>
          </el-form-item>

          <el-form-item class="col2" style="margin-top:-20px">
            <el-button type="primary" class="submitBtn" @click.native.prevent="submit">登录</el-button>

            <!-- <el-button type="primary" class="submitBtn" @click.native.prevent="ForgetPasswordbtn">修改密码</el-button> -->
            <el-button type="primary" class="submitBtn" @click.native.prevent="subrecive">重置</el-button>
          </el-form-item>
          <!-- <el-form-item style="margin-top:-20px;">
                        <el-col :span="12" class="font-14 fontcolor" style="text-align:right;">没有账号,立即</el-col>
                        <el-col :span="12"><a href="javascript:void(0);" @click="handleRegisterBtn">注册</a></el-col>
          </el-form-item>-->
      
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { login } from "@/api/user/login";

import { GetVerifyCode } from "@/api/user/userInfo";

export default {
  data() {
    return {
      checkRecord: false,
      verifyCode: "",
      ReginForm: {
        oldPass: "",
        newPass: "",
        checkPass: "",
        show: {
          old: false,
          new: false,
          check: false
        },
        imgId: 0,
        imgCode: "",
        password: "",
        userName: "",
        usertype: "user"
      },
      logining: false,
      sendAuthCode: true,
      /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
      auth_time: 0,
      /*倒计时 计数器*/
      verification: "", //绑定输入验证码框框
      rule: {
        password: [
          {
            required: true,
            message: "请输入密码！",
            trigger: "blur"
          }
        ],
        userName: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {},
  mounted() {
    if (
      window.localStorage.getItem("userName") == null ||
      window.localStorage.getItem("userName") == ""
    ) {
      this.ReginForm.userName = "";
      this.checkRecord = false;
    } else {
      this.ReginForm.userName = window.localStorage.getItem("userName");
      this.checkRecord = true;
    }

    this.GetImgCode();
  },
  methods: {
    ...mapMutations(["Login", "Setoutflag", "recordphone"]),

    GetImgCode() {
      GetVerifyCode().then(res => {
        // //console.log(res)
        this.verifyCode = res.data.verityImg;
        this.ReginForm.imgId = res.data.imgId;
      });
    },
    //重置
    subrecive() {
      this.ReginForm.userName = "";
      this.ReginForm.password = "";
      this.ReginForm.imgCode = "";
    },
    // ...
    submit() {
  this.$refs.ReginForm.validate(valid => {
    if (valid) {
      this.logining = true;
      if (this.checkRecord) {
        this.recordphone(this.ReginForm.userName);
      } else {
        this.recordphone("");
      }
      let newuserinfo = {
        userName: this.ReginForm.userName,
        password: this.ReginForm.password,
        imgId: this.ReginForm.imgId,
        imgCode: this.ReginForm.imgCode
      };
      login(newuserinfo).then(res => {
      //  console.log(res);
       
        if (res.status === 0) {
          this.Login(res.data)
          this.$router.push("/mangement");
        }
        if (res.status === -5001) {
          this.$message.error("用户名或密码错误!");
        } else if (res.status === -5007) {
          this.$message.error("用户已在线！");
        } else if (res.status === -5006) {
          this.$message.error("人员数量超过限制请联系管理员！");
        } else if (res.status === -5005) {
          this.$message.error("验证码错误！");
        }
      });
    } else {
      console.log("submit err");
    }
  });
},

    reset() {
      this.$refs.ReginForm.resetFields();
    },
    ForgetPasswordbtn() {
      //已经注册过跳转到登入界面
      this.$router.push("/forgetpassword");
    },

    handleRegisterBtn() {
      this.$router.push("/register");
    },
    changecheck() {
      if (this.ReginForm.userName.trim() != "") {
        if (this.checkRecord) {
          this.recordphone(this.ReginForm.userName);
        } else {
          this.recordphone("");
        }
      }
    },
    initSocket() {
      const wsurl = "ws://localhost:6060/websocket/1";
      const ws = new WebSocket(wsurl);

      this.Socket = ws;
      this.Socket.onopen = this.open;
      this.Socket.onerror = this.onError;
      this.Socket.onmessage = this.onMessage;
      this.Socket.onclose = this.onClose;
    },
    open(e) {
      //console.log("Socket 连接成功")
      this.Socket.send("这是来自客户端");
    },

    onMessage(e) {
      //console.log(e)
    },

    onError(e) {
      //console.log("Socket发生错误");
    },
    onClose() {
      this.Socket.close();
      //console.log("关闭");
    },

    // 点击登录按钮
    handleLoginBtn() {
      // this.initSocket()
    },
    // 验证
    validaphoneogin() {
      if (this.username === "") {
        this.$message.error("请输入用户名");
        return false;
      }

      if (this.password === "") {
        this.$message.error("请输入密码");
        return false;
      }

      if (this.password.length < 6 || this.password.length > 12) {
        this.$message.error("密码位数为6到12位");
        return false;
      }
      return true;
    }
  },
  destroyed() {
    // alert("銷毀")
    // this.onClose()
  }
};
</script>
  <style scoped >
  .title{
    font-size: 24px;
    color: #ffffff;
  }
  .title1{
    text-align: center;
  }
.pastop {
  margin-top: 25px;
  width: 140%;
}
.submitBtn{
  margin-top: 15%;
  background-color: #416ea1e8;
}
.col2 {
  text-align: center;
}


.to {
  color: #115599a0;
  cursor: pointer;
}


.login-text {
  text-align: center;
  margin-top: 1px;
  margin-bottom: 40px;
}

#login {
  width: 100%;
  height: 100%;
  background: url("../assets/images/login.jpg") no-repeat;
  background-size: cover;
  position: absolute;
}
.center {
width: 100%;
}
    .loginbox img {
      width: 31%;
      height: 7%;
      top: calc(23%);
      left: calc(32%);
      position: absolute;
    }
    .content {
      width: 27%;
      height: 40%;
      top: calc(55%);
      left: calc(63%);
      background-color:#2752726d;
      background-size: cover;
      position: absolute;
      padding: 10px 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
      .content_tip {
        text-align: right;
        font-size: 14px;
        color: #37acfe;
        height: 14px;
        margin-top: 20px;
        margin-bottom: 20px;
        cursor: pointer;
      }


    .center {
      width: 1500px;
    }


  .bottom {
    height: 50px;
    width: 100%;
    position: absolute;
    bottom: 0;
    text-align: center;
    font-size: 12px;
    line-height: 50px;
    color: #131997;
  }


.span_red {
  color: rgb(255, 0, 0);
}

.col1 {
  width: 80%;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/login.vue